/*
  JIALIJIDIAN global page animations.
  The script only adds reveal classes after it runs, so pages remain visible if JS fails.
*/
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion || !('IntersectionObserver' in window)) {
    return;
  }

  var roots = document.querySelectorAll(
    '.wf-about, .wf-contact, .wf-projects-page, .wf-cart, .industrial-product'
  );

  if (!roots.length) {
    return;
  }

  var maxRevealItems = 80;
  var visibleLine = window.innerHeight * 0.95;
  var revealSelectors = [
    '[class$="__hero"]',
    '[class$="__hero-inner"]',
    '[class$="__hero-copy"]',
    '[class$="__hero-panel"]',
    '[class$="__band"]',
    '[class$="__section-head"]',
    '[class$="__intro-copy"]',
    '[class$="__intro-media"]',
    '[class$="__form-card"]',
    '[class$="__info-card"]',
    '[class$="__quick-card"]',
    '[class$="__map"]',
    '[class$="__stats"]',
    '[class$="__stat"]',
    '[class$="__case"]',
    '[class$="__process"]',
    '[class$="__cta"]',
    '[class$="__items"]',
    '[class$="__item"]',
    '[class$="__summary"]',
    '[class$="__trust"]',
    '[class$="__main"]',
    '[class$="__media"]',
    '[class$="__details"]',
    '[class$="__panel"]',
    '.wf-about__value',
    '.wf-about__timeline-item',
    '.wf-about__certificate',
    '.wf-product-list-card'
  ];

  var countSelector = [
    '.wf-projects-page__stat strong',
    '.wf-contact__hero-panel strong',
    '.wf-collection__hero-panel span'
  ].join(',');

  function parseCount(text) {
    var value = String(text || '').match(/\d+/);
    return value ? parseInt(value[0], 10) : null;
  }

  function animateCount(element) {
    if (element.dataset.wfCounted === 'true') {
      return;
    }

    var original = element.textContent.trim();
    var target = parseCount(original);
    if (!target || target > 9999) {
      return;
    }

    element.dataset.wfCounted = 'true';
    var start = performance.now();
    var duration = 900;

    function tick(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);
      element.textContent = original.replace(/\d+/, String(current));

      if (progress < 1) {
        window.requestAnimationFrame(tick);
      } else {
        element.textContent = original;
      }
    }

    window.requestAnimationFrame(tick);
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }

        entry.target.classList.add('is-visible');

        if (entry.target.matches(countSelector)) {
          animateCount(entry.target);
        }

        entry.target.querySelectorAll(countSelector).forEach(animateCount);
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.16
    }
  );

  function initRoot(root) {
    var elements = Array.prototype.slice.call(root.querySelectorAll(revealSelectors.join(',')), 0, maxRevealItems);

    elements.forEach(function (element, index) {
      var rect = element.getBoundingClientRect();
      var isInitiallyVisible = rect.top < visibleLine;

      element.classList.add('wf-reveal');
      if (isInitiallyVisible) {
        element.classList.add('is-visible');
      } else {
        element.style.setProperty('--wf-reveal-delay', Math.min(index % 4, 3) * 35 + 'ms');
        observer.observe(element);
      }
    });

    /*
      The ready class is added after first-screen elements are already visible,
      avoiding a brief hide/show during page navigation.
    */
    root.classList.add('wf-global-animate-ready');
  }

  window.requestAnimationFrame(function () {
    roots.forEach(initRoot);
  });
})();
